// extracted by mini-css-extract-plugin
module.exports = {"row":"Tags_row__2NmiV","tags":"Tags_tags__RS22g","tag":"Tags_tag__3GrMD","count":"Tags_count__11S0s"};